// extracted by mini-css-extract-plugin
export default {"toCheckoutContainer":"style_toCheckoutContainer__kMT7w","text":"style_text__iSZI9","button":"style_button__8ZqmQ"};